module.exports = __webpack_public_path__ + "static/media/ic_drag.d29d1337.svg";